import React from 'react';
import './legal-pages.css';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <header className="legal-header">
          <h1>利用規約</h1>
          <p className="last-updated">最終更新日：2024年8月16日</p>
        </header>

        <div className="legal-body">
          <section className="legal-section">
            <h2>第1条（適用）</h2>
            <p>
              本規約は、生成AI Boost LMS（以下「当サービス」）の利用に関して、
              当サービスを提供する運営事務局（以下「当社」）とユーザーとの間の権利義務関係を定めるものです。
              ユーザーは、当サービスを利用することにより、本規約に同意したものとみなします。
            </p>
          </section>

          <section className="legal-section">
            <h2>第2条（定義）</h2>
            <p>本規約において、以下の用語は以下の意味を有するものとします。</p>
            <ol>
              <li><strong>「当サービス」</strong>とは、当社が提供する学習管理システム「生成AI Boost LMS」をいいます。</li>
              <li><strong>「ユーザー」</strong>とは、当サービスを利用する個人をいいます。</li>
              <li><strong>「ユーザーコンテンツ」</strong>とは、ユーザーが当サービスに投稿、アップロード、送信等したあらゆる情報をいいます。</li>
              <li><strong>「知的財産権」</strong>とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）をいいます。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第3条（利用登録）</h2>
            <ol>
              <li>当サービスの利用を希望する者は、本規約に同意の上、当社の定める方法によって利用登録を申請するものとします。</li>
              <li>当社は、前項の申請があった場合、当社の基準に従って審査を行い、当社が適当と認めた場合にのみ利用登録を承認するものとします。</li>
              <li>当社は、利用登録の申請者が以下のいずれかに該当する場合には、利用登録を承認しないことがあります。
                <ul>
                  <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
                  <li>本規約に違反したことがある者からの申請である場合</li>
                  <li>未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人、保佐人又は補助人の同意等を得ていない場合</li>
                  <li>その他、当社が利用登録を相当でないと判断した場合</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第4条（アカウント情報の管理）</h2>
            <ol>
              <li>ユーザーは、自己の責任において、当サービスのアカウント情報を適切に管理するものとします。</li>
              <li>ユーザーは、アカウント情報を第三者に利用させ、または貸与、譲渡、名義変更、売買等をしてはならないものとします。</li>
              <li>アカウント情報の管理不十分、使用上の過誤、第三者の使用等によって生じた損害について、当社は一切の責任を負わないものとします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第5条（利用料金及び支払方法）</h2>
            <ol>
              <li>当サービスの利用料金は、当社ウェブサイトに掲載する料金表に定める通りとします。</li>
              <li>ユーザーは、当社が指定する方法により、前項の利用料金を支払うものとします。</li>
              <li>ユーザーが利用料金の支払を遅滞した場合には、ユーザーは年14.6％の割合による遅延損害金を支払うものとします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第6条（禁止事項）</h2>
            <p>ユーザーは、当サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ol>
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当社、他のユーザー、または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
              <li>当サービスの運営を妨害するおそれのある行為</li>
              <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
              <li>不正アクセスをし、またはこれを試みる行為</li>
              <li>他のユーザーに成りすます行為</li>
              <li>当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
              <li>宗教活動または宗教団体への勧誘行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第7条（学習コンテンツの利用）</h2>
            <ol>
              <li>当サービスで提供される学習コンテンツの知的財産権は、当社または当社にライセンスを許諾している者に帰属します。</li>
              <li>ユーザーは、学習コンテンツを個人的な学習目的でのみ利用することができ、複製、配布、公衆送信等を行ってはならないものとします。</li>
              <li>ユーザーが学習コンテンツを不正に利用した場合、当社は当該ユーザーに対して損害賠償を請求できるものとします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第8条（ユーザーコンテンツ）</h2>
            <ol>
              <li>ユーザーは、自己が投稿等するユーザーコンテンツについて、自己が適法な権利を有していることを表明し、保証するものとします。</li>
              <li>ユーザーは、ユーザーコンテンツについて、当社に対し、世界的、非独占的、無償、サブライセンス可能かつ譲渡可能な使用許諾を行うものとします。</li>
              <li>当社は、ユーザーコンテンツが第6条に定める禁止事項に該当し、または該当するおそれがあると判断した場合には、事前の通知なくこれを削除することができるものとします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第9条（利用制限及び登録抹消）</h2>
            <ol>
              <li>当社は、ユーザーが以下のいずれかに該当する場合には、事前の通知なく、当該ユーザーに対してサービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
                <ul>
                  <li>本規約のいずれかの条項に違反した場合</li>
                  <li>登録事項に虚偽の事実があることが判明した場合</li>
                  <li>当社からの連絡に対し、一定期間返答がない場合</li>
                  <li>当サービスについて、最後の利用から一定期間利用がない場合</li>
                  <li>その他、当社がサービスの利用を適当でないと判断した場合</li>
                </ul>
              </li>
              <li>前項各号のいずれかに該当した場合、ユーザーは、当然に当社に対する一切の債務について期限の利益を失い、その時点において負担する一切の債務を直ちに一括して弁済しなければなりません。</li>
              <li>当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第10条（保証の否認及び免責事項）</h2>
            <ol>
              <li>当社は、当サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティホール、エラーやバグ、権利侵害等を含みます。）がないことを明示的にも黙示的にも保証しておりません。</li>
              <li>当社は、当サービスに起因してユーザーに生じたあらゆる損害について、当社の故意又は重過失による場合を除き、一切の責任を負いません。</li>
              <li>前項ただし書に定める場合であっても、当社は、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、一切の責任を負いません。</li>
              <li>当サービスに関連してユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について、当社は一切責任を負いません。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第11条（サービス内容の変更等）</h2>
            <p>
              当社は、ユーザーへの事前の告知をもって、当サービスの内容を変更、追加または廃止することがあり、
              ユーザーはこれに同意するものとします。
            </p>
          </section>

          <section className="legal-section">
            <h2>第12条（利用規約の変更）</h2>
            <ol>
              <li>当社は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。
                <ul>
                  <li>本規約の変更がユーザーの一般の利益に適合するとき。</li>
                  <li>本規約の変更が本契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。</li>
                </ul>
              </li>
              <li>当社はユーザーに対し、前項による本規約の変更にあたり、事前に、本規約を変更する旨及び変更後の本規約の内容並びにその効力発生時期を通知いたします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第13条（個人情報の取扱い）</h2>
            <p>
              当社は、当サービスの利用によって取得する個人情報については、
              当社「プライバシーポリシー」に従い適切に取り扱うものとします。
            </p>
          </section>

          <section className="legal-section">
            <h2>第14条（通知または連絡）</h2>
            <p>
              ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。
              当社は、ユーザーから、当社が別途定める方式に従った変更届出がない限り、
              現在登録されている連絡先が有効なものとみなして当該連絡先に通知または連絡を行い、
              これらは、発信時にユーザーに到達したものとみなします。
            </p>
          </section>

          <section className="legal-section">
            <h2>第15条（権利義務の譲渡の禁止）</h2>
            <p>
              ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、
              または担保に供することはできません。
            </p>
          </section>

          <section className="legal-section">
            <h2>第16条（適用法・管轄裁判所）</h2>
            <ol>
              <li>本規約の解釈にあたっては、日本法を適用するものとします。</li>
              <li>当サービスに関して紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄とします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第17条（反社会的勢力の排除）</h2>
            <ol>
              <li>ユーザーは、自らが、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団等、その他これらに準ずる者（以下「反社会的勢力」という。）のいずれでもないこと、及び将来にわたってもいずれでもないことを表明し、かつ保証するものとします。</li>
              <li>ユーザーは、直接または間接を問わず反社会的勢力と一切の関係を持たず、反社会的勢力に対して資金等を提供し、または便宜を供与する等の取引を行わないことを保証するものとします。</li>
              <li>当社は、ユーザーが前各項の規定に違反した場合、何らの催告なしに直ちに本契約を解除できるものとし、これによりユーザーに損害が生じても一切責任を負わないものとします。</li>
            </ol>
          </section>

          <section className="legal-section">
            <h2>第18条（存続条項）</h2>
            <p>
              本規約第5条、第7条、第8条、第10条、第13条、第15条、第16条及び第17条の規定は、
              何らかの理由により利用契約が終了した場合であっても、有効に存続するものとします。
            </p>
          </section>

          <section className="legal-section">
            <h2>第19条（その他）</h2>
            <ol>
              <li>本規約の一部が無効または執行不能と判断された場合であっても、当該判断は他の部分の有効性または執行可能性に影響を与えないものとします。</li>
              <li>本規約に定めのない事項については、誠意をもって協議の上解決するものとします。</li>
            </ol>
          </section>
        </div>

        <div className="legal-footer">
          <p>以上</p>
          <p className="company-name">生成AI Boost LMS 運営事務局</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;